import { userLanguage, ValidLanguages } from '$translations/index';
import {
  ErrorMessageEn,
  ErrorMessageEs,
  SuccessMessageEn,
  SuccessMessageEs,
} from '../../../../constants/alerts';
import { errorHandler, successHandler } from '../../../utils';
import {
  UploadBuilder,
  UploadProfilePictureAsInternalInput,
  UploadProfilePictureAsInternalOutput,
} from '../uploads.types';

export const uploadCandidateProfilePictureAsInternal = (
  builder: UploadBuilder
) =>
  builder.mutation<
    UploadProfilePictureAsInternalOutput,
    UploadProfilePictureAsInternalInput
  >({
    query: (args) => ({
      url: `/upload/profile-picture/${args.userId}`,
      method: 'POST',
      body: args.file,
    }),
    transformResponse: (res: UploadProfilePictureAsInternalOutput) => {
      successHandler(
        userLanguage === ValidLanguages.es
          ? SuccessMessageEs.UpdateCandidate
          : SuccessMessageEn.UpdateCandidate,
        true
      );
      return res;
    },
    transformErrorResponse: (err) => {
      errorHandler(
        '[uploadCVAction]',
        userLanguage === ValidLanguages.es
          ? ErrorMessageEs.UploadProfilePicture
          : ErrorMessageEn.UploadProfilePicture,
        err,
        true
      );
      return err.data;
    },
  });
